"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TS1ProcessorType = void 0;
var TS1ProcessorType;
(function (TS1ProcessorType) {
    TS1ProcessorType["STRIPE"] = "stripe";
})(TS1ProcessorType || (exports.TS1ProcessorType = TS1ProcessorType = {}));
